import {Component, OnInit, ViewChild} from '@angular/core';
import {DataObjEditComponent, DataObjEditComponentHelper, Select2Data} from '../../rest-service';
import {Extension, ExtensionService} from '../../extension.service';
import {Department, DepartmentService} from '../../department.service';
import {CostCenter, CostCenterService} from '../../cost-center.service';
import {SelectComponent} from 'ng2-select';
import {PhoneNumber, PhoneNumberService} from '../../phone-number.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NotificationService} from '../../notification.service';
import {BillingUser, UserService} from '../../user.service';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-extension-edit',
  templateUrl: './extension-edit.component.html',
  styleUrls: ['./extension-edit.component.css']
})
export class ExtensionEditComponent implements OnInit, DataObjEditComponent<Extension> {

  // name of the object in the singular
  readonly vowelSingular = 'o Ramal';

  readonly entityPath = '/extensions';

  isRange = false;

  departments: Department[];
  costCenters: CostCenter[];
  billingUsers: BillingUser[];

  departmentsSelectData: Select2Data[] = [];
  costCentersSelectData: Select2Data[] = [];
  billingUsersSelectData: Select2Data[] = [];

  @ViewChild('select_department') selectDepartment: SelectComponent;
  @ViewChild('select_cost_center') selectCostCenter: SelectComponent;
  @ViewChild('select_billing_user') selectBillingUser: SelectComponent;

  helper: DataObjEditComponentHelper<Extension>;

  readonly defaultObj = new Extension(null, new PhoneNumber('55', '', '', ''),
    '', null, null, null, false, null, null, null);

  controlsConfigs = [{
    'number': ['', Validators.required],
    'enableRange': [''],
    'range': ['', Validators.maxLength(4)],
    'description': ['', Validators.required],
    'departmentId': ['', Validators.required],
    'costCenterId': ['', Validators.required],
    'userId': [''],
  }];

  validationMessages = [
    {
      'number': {
        'required': 'Número não informado'
      },
      'range': {
        'required': 'Número não informado'
      },
      'description': {
        'required': 'Descrição não informada'
      },
      'departmentId': {
        'required': 'Departamento não selecionado'
      },
      'costCenterId': {
        'required': 'Centro de custo não selecionado'
      }
    }
  ];

  constructor(private fb: FormBuilder, public router: Router, public route: ActivatedRoute, public ns: NotificationService,
              public service: ExtensionService, public us: UserService, public ds: DepartmentService, public cs: CostCenterService) {
    this.helper = new DataObjEditComponentHelper(fb, this.controlsConfigs, this.validationMessages, this.entityPath,
      this.router, this.ns, this.service, this);
  }

  ngOnInit() {
    this.helper.buildForm();
    this.selectDepartment.active = [];
    this.selectCostCenter.active = [];
    this.selectBillingUser.active = [];
    this.route.params.switchMap((params: Params) => {
      const id = params['id'];
      return this.processId(id);
    }).subscribe((obj: Extension) => {
      this.helper.actualObj = obj;
      this.refreshModel(obj);
    });
    this.helper.formGroups.forEach((formGroup, index, array) =>
      formGroup.valueChanges.debounceTime(250).subscribe((data) => {
        this.helper.onValueChanges(data, index)
        this.updateUi(data);
      }));
  }

  processId(id: string) {
    if (id && id !== '') {
      this.helper.editing = true;
      return this.service.getById(id);
    } else {
      this.helper.editing = false;
      return Observable.of(this.defaultObj);
    }
  }

  validateFields(index: number, defaultFormErrors: any): Observable<any> {
    if (index === 0) {
      this.validateRange(defaultFormErrors);
      const number = this.helper.formGroups[0].get('number').value;
      if (!isNullOrUndefined(number) && number !== '' && !this.helper.editing) {
        const phoneNumber = PhoneNumberService.parse(number);
        if (!isNullOrUndefined(phoneNumber)) {
          return this.service.countByCustomerIdAndNumber(this.us.currentUser.getValue().customerDatabaseId, phoneNumber)
            .map((value) => {
              if (value !== 0) {
                console.log(`Extension number already used by ${value} extensions...`);
                if (isNullOrUndefined(defaultFormErrors['number'])) {
                  defaultFormErrors['number'] = new Array<string>();
                }
                defaultFormErrors['number'].push('Ramal já cadastrado!');
                this.helper.formInvalid[index] = true;
              }
              return defaultFormErrors;
            });
        } else {
          if (isNullOrUndefined(defaultFormErrors['number'])) {
            defaultFormErrors['number'] = new Array<string>();
          }
          defaultFormErrors['number'].push('Número do Ramal inválido!');
          this.helper.formInvalid[index] = true;
          return Observable.of(defaultFormErrors);
        }
      } else {
        return Observable.of(defaultFormErrors);
      }
    }
  }

  validateRange(defaultFormErrors: any) {
    const enableRange = this.helper.formGroups[0].get('enableRange').value;
    if (enableRange) {
      const rangeControl = this.helper.formGroups[0].get('range');
      if (!isNullOrUndefined(rangeControl.value) && rangeControl.value !== '') {
        const value = rangeControl.value;
        if (value.toString().length !== 4) {
          if (isNullOrUndefined(defaultFormErrors['range'])) {
            defaultFormErrors['range'] = new Array<string>();
          }
          defaultFormErrors['range'].push('Range Inválido');
          this.helper.formInvalid[0] = true;
        } else {
          const rangeEnd = parseInt(rangeControl.value, 10);
          const numberStr = this.helper.formGroups[0].get('number').value.toString();
          const rangeStart = parseInt(numberStr.substr(numberStr.length - 4), 10);
          // console.log(`start:${rangeStart} end:${rangeEnd}`);
          if (rangeStart >= rangeEnd) {
            if (isNullOrUndefined(defaultFormErrors['range'])) {
              defaultFormErrors['range'] = new Array<string>();
            }
            defaultFormErrors['range'].push('Final deve ser maior que o início');
          }
        }
      }
    }
    return defaultFormErrors;
  }

  trySave(index: number, model: any) {
    this.helper.preSave();
    console.log(`Trying to save: ${JSON.stringify(model)}`);
    this.helper.isAllValid(index).subscribe((valid) => {
      if (valid) {
        const obj = this.fromModel(model);
        if (!this.isRange) {
          this.helper.decideOperation(obj).subscribe((res) => {
            this.helper.processResult(index, res);
            this.helper.formGroups.forEach((formGroup, idx, array) =>
              formGroup.valueChanges.debounceTime(250).subscribe((data) => this.helper.onValueChanges(data, idx)));
            if (this.helper.editing) {
              this.refreshModel(obj);
            } else {
              this.refreshModel(this.defaultObj);
            }
          }, (error) => {
            console.log(`Error Saving object: '${obj}': ${JSON.stringify(error)}`);
            this.ns.error(error.toString(), 'Erro ao salvar');
          }, () => {
            this.helper.postSave();
          });
        } else {
          if (!this.helper.editing) {
            const end: PhoneNumber = Object.create(PhoneNumber.prototype);
            Object.assign(end, obj.number);
            end.extension = this.helper.formGroups[0].get('range').value;
            this.service.saveRange(obj, obj.number, end).subscribe(
              (res) => {
                this.ns.success(`Sucesso: ${res.success} Ramais\nErro: ${res.error}`, 'Executado com Sucesso');
                this.router.navigateByUrl(`${this.entityPath}`);
                this.helper.formGroups.forEach((formGroup, idx, array) =>
                  formGroup.valueChanges.debounceTime(250).subscribe((data) => this.helper.onValueChanges(data, idx)));
                this.refreshModel(this.defaultObj);
              }, (error) => {
                console.log(`Error Saving Range of object: '${obj}': ${JSON.stringify(error)}`);
                this.ns.error(error.toString(), 'Erro ao salvar');
              }
              , () => this.helper.postSave()
            );
          }
        }
      } else {
        console.log(`NotSaving because something is invalid...`);
        this.helper.postSave();
      }
    }, (error) => {
      this.ns.error(error.toString(), 'Erro ao salvar');
    });
  }

  updateUi(data: any) {
    if (data.enableRange) {
      this.isRange = true;
    } else {
      this.isRange = false;
    }
  }

  setDepartment(data: any) {
    this.helper.formGroups[0].controls['departmentId'].patchValue(data.id);
  }

  setCostCenter(data: any) {
    this.helper.formGroups[0].controls['costCenterId'].patchValue(data.id);
  }

  setBillingUser(data: any) {
    this.helper.formGroups[0].controls['userId'].patchValue(data.id);
  }

  fromModel(model: any): Extension {
    let id = null;
    if (this.helper.editing) {
      id = this.helper.actualObj.id;
    }
    let departmentId = null;
    if (!isNullOrUndefined(this.selectDepartment.active[0])) {
      departmentId = this.selectDepartment.active[0].id;
    }
    let costCenterId = null;
    if (!isNullOrUndefined(this.selectCostCenter.active[0])) {
      costCenterId = this.selectCostCenter.active[0].id;
    }
    let userId = null;
    if (!isNullOrUndefined(this.selectBillingUser.active[0])) {
      userId = this.selectBillingUser.active[0].id;
    }
    return new Extension(id, PhoneNumberService.parse(model.number), model.description,
      this.us.currentUser.getValue().customerDatabaseId, departmentId, costCenterId, false,
      null, null, userId);
  }

  toModel(obj: Extension, fg: FormGroup) {
    fg.controls['description'].patchValue(obj.description);
    fg.controls['number'].patchValue(obj.number.getLDFormat());
    fg.controls['departmentId'].patchValue(obj.departmentId);
    fg.controls['costCenterId'].patchValue(obj.costCenterId);
    fg.controls['userId'].patchValue(obj.userId);
    fg.controls['enableRange'].patchValue(false);
    fg.controls['range'].patchValue('');
    this.selectDepartment.active = this.helper.getSelectActiveObject(obj.departmentId, this.departmentsSelectData);
    this.selectCostCenter.active = this.helper.getSelectActiveObject(obj.costCenterId, this.costCentersSelectData);
    this.selectBillingUser.active = this.helper.getSelectActiveObject(obj.userId, this.billingUsersSelectData);
  }

  refreshModel(obj: Extension) {
    Observable.forkJoin(
      this.ds.getAllByCustomerId(this.us.currentUser.getValue().customerDatabaseId),
      this.cs.getAllByCustomerId(this.us.currentUser.getValue().customerDatabaseId),
      this.us.getAllBillingUsers(this.us.currentUser.getValue().customerDatabaseId))
      .subscribe((data) => {
        this.departments = data[0];
        this.costCenters = data[1];
        this.billingUsers = data[2];
        this.departmentsSelectData = DepartmentService.getDepartmentsSelectData(this.departments, null);
        this.costCentersSelectData = this.costCenters.map((costCenter) => {
          return {id: costCenter.id, text: costCenter.description}
        });
        this.billingUsersSelectData = this.billingUsers.map((billingUser) => {
          return {id: billingUser.userId, text: `${billingUser.name} (${billingUser.username})`}
        });
        this.toModel(obj, this.helper.formGroups[0]);
      });
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/extension/extension-edit/extension-edit.component.ts